import { create } from 'zustand';

export interface Toast {
  id: number;
  message: string;
  action?: { label: string; onClick: () => void };
  variant: 'default' | 'error';
}

interface ToastState {
  toasts: Toast[];
  dismiss: (id: number) => void;
}

let nextId = 1;
const timers = new Map<number, ReturnType<typeof setTimeout>>();

export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  dismiss: (id) => {
    clearTimeout(timers.get(id));
    timers.delete(id);
    set((state) => ({ toasts: state.toasts.filter((t) => t.id !== id) }));
  },
}));

/**
 * Affiche un message en bas de l'écran (le « snackbar » de Keep), avec une action facultative
 * — typiquement « Annuler ». Un nouveau message remplace le précédent, comme dans Keep.
 */
export function toast(
  message: string,
  options: { action?: Toast['action']; variant?: Toast['variant']; duration?: number } = {},
) {
  const id = nextId++;
  const { dismiss } = useToasts.getState();
  for (const existing of useToasts.getState().toasts) dismiss(existing.id);
  useToasts.setState({
    toasts: [{ id, message, action: options.action, variant: options.variant ?? 'default' }],
  });
  timers.set(
    id,
    setTimeout(() => dismiss(id), options.duration ?? (options.action ? 6000 : 4000)),
  );
  return id;
}

export const toastError = (message: string) => toast(message, { variant: 'error' });
